import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils/buildUrl";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import { ISkill } from "../skills/skills.types";
import {
    IPolicyType,
    IPolicyTypeCreate,
    IPolicyTypeUpdate,
} from "./policy-types.types";

const API = `${API_URL}/policy-types`;

export const getPolicyTypes = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter,
    search?: string | null
) => {
    const url = buildUrl(API, { page, size, search, ...filter });
    const result = await axios.get<Page<IPolicyType>>(url);
    return result.data;
};

export const getPolicyTypesUnpaginated = async () => {
    const result = await axios.get<IPolicyType[]>(`${API}/all`);
    return result.data;
};

export const getPolicyTypeById = async (id: number) => {
    const result = await axios.get<IPolicyType>(`${API}/${id}`);
    return result.data;
};

export const createPolicyType = async (data: IPolicyTypeCreate) => {
    const result = await axios.post<IPolicyType>(API, data);
    return result.data;
};

export const updatePolicyType = async (id: number, data: IPolicyTypeUpdate) => {
    const result = await axios.put<IPolicyType>(`${API}/${id}`, data);
    return result.data;
};

export const deletePolicyType = async (id: number) => {
    const result = await axios.delete(`${API}/${id}`);
    return result.data;
};

export const generatePolicyTypeSkill = async (id: number) => {
    const result = await axios.post<ISkill>(`${API}/${id}/generate-skill`);
    return result.data;
};
